import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';

import enApp from '../locales/en/app.json';
import enComponent from '../locales/en/component.json';
import enError from '../locales/en/error.json';
import enPage from '../locales/en/page.json';
import enSchema from '../locales/en/schema.json';

import frApp from '../locales/fr/app.json';
import frComponent from '../locales/fr/component.json';
import frError from '../locales/fr/error.json';
import frPage from '../locales/fr/page.json';
import frSchema from '../locales/fr/schema.json';

i18next
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: process.env.NODE_ENV === 'development',
    lng: 'fr',
    fallbackLng: 'fr',
    ns: ['app', 'page', 'schema', 'error', 'component'],
    defaultNS: 'page',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        app: enApp,
        component: enComponent,
        error: enError,
        page: enPage,
        schema: enSchema,
      },
      fr: {
        app: frApp,
        component: frComponent,
        error: frError,
        page: frPage,
        schema: frSchema,
      },
    },
  });

export default i18next;
